/* BLNKA card interactions. 2 Sep 2026.

   HOVER A COLOUR SWATCH -> the card image becomes that colour's photo.
   Leaving the swatch row puts the original photo back. Clicking locks a
   colour so it survives the pointer leaving.

   WHY CLICK IS STILL HERE.
   Hover does not exist on touch. If this responded to hover alone, every
   phone and tablet would lose the feature outright, and the collection grid
   is the most-used screen on those devices. Click is the touch path and the
   keyboard path; hover is the desktop convenience layered on top.

   DELEGATION.
   Bound to document, not to each swatch, so the collection grid's
   append-in-place Load More does not need to rebind anything. mouseover and
   mouseout are used rather than mouseenter/mouseleave because only the former
   pair bubbles, which delegation depends on. The mouseout handler checks
   relatedTarget so moving between two swatches inside the same row does not
   count as leaving it.

   srcset AND sizes ARE REMOVED BEFORE src IS SET.
   With a srcset still present the browser keeps choosing a candidate from the
   old set and the swap appears to do nothing. Both are stashed on the element
   first so the original responsive image can be restored exactly.

   THE HOVER IMAGE HAS TO BE RETIRED DURING A PREVIEW.
   It is stacked above the main image, so without .blnka-card--swatched the
   swapped-in photo sits underneath it and nothing appears to change while the
   pointer is still on the card. */
(function () {
  if (window.__blnkaCardFx) return;
  window.__blnkaCardFx = true;

  var SW = 'button.blnka-card__sw';

  function mainImg(card) {
    return card ? card.querySelector('.blnka-card__img--main') : null;
  }

  function swap(card, url) {
    var img = mainImg(card);
    if (!img || !url) return;
    if (img.getAttribute('data-blnka-orig-src') === null) {
      img.setAttribute('data-blnka-orig-src', img.getAttribute('src') || '');
      img.setAttribute('data-blnka-orig-srcset', img.getAttribute('srcset') || '');
      img.setAttribute('data-blnka-orig-sizes', img.getAttribute('sizes') || '');
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = url;
    card.classList.add('blnka-card--swatched');
  }

  function restore(card) {
    var img = mainImg(card);
    if (!img) return;
    var src = img.getAttribute('data-blnka-orig-src');
    if (src === null) return;
    var set = img.getAttribute('data-blnka-orig-srcset') || '';
    var szs = img.getAttribute('data-blnka-orig-sizes') || '';
    img.src = src;
    if (set) img.setAttribute('srcset', set); else img.removeAttribute('srcset');
    if (szs) img.setAttribute('sizes', szs); else img.removeAttribute('sizes');
    card.classList.remove('blnka-card--swatched');
  }

  function mark(group, active) {
    if (!group) return;
    var all = group.querySelectorAll(SW);
    for (var i = 0; i < all.length; i++) {
      all[i].setAttribute('aria-pressed', all[i] === active ? 'true' : 'false');
    }
  }

  /* ---- hover in ---- */
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SW);
    if (!btn) return;
    var card = btn.closest('.blnka-card');
    if (!card) return;
    swap(card, btn.getAttribute('data-img'));
    mark(btn.closest('.blnka-card__swatches'), btn);
  });

  /* ---- hover out: only when the pointer truly leaves the swatch row ---- */
  document.addEventListener('mouseout', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SW);
    if (!btn) return;

    var group = btn.closest('.blnka-card__swatches');
    var to = e.relatedTarget;
    if (group && to && group.contains(to)) return;

    var card = btn.closest('.blnka-card');
    if (!card || card.classList.contains('blnka-card--swatch-locked')) return;

    restore(card);
    mark(group, null);
  });

  /* ---- click: touch and keyboard path, and locks the choice ---- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest(SW);
    if (!btn) return;
    var card = btn.closest('.blnka-card');
    if (!card) return;

    e.preventDefault();

    var group = btn.closest('.blnka-card__swatches');

    /* Pressing the locked colour again releases it. */
    if (card.classList.contains('blnka-card--swatch-locked') && btn.getAttribute('aria-pressed') === 'true') {
      card.classList.remove('blnka-card--swatch-locked');
      restore(card);
      mark(group, null);
      return;
    }

    swap(card, btn.getAttribute('data-img'));
    card.classList.add('blnka-card--swatch-locked');
    mark(group, btn);
  });
})();
